// extracted by mini-css-extract-plugin
export default {"practice":"Practice_practice__cOXs8"};